
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop isResolved     是否已解决
 * @prop satisfaction   满意度 id
*/
@Component({
    name: 'evaluation-pannel'
})
export default class extends Vue {
    @Prop({ default: false }) private isResolved!: boolean
    @Prop({ default: '' }) private satisfaction!: number

    get satisfactions() {
        return [
            { 
                id: 10,
                name: '不满意',
                icon: 'icon-bumanyi'
            },
            { 
                id: 20,
                name: '一般',
                icon: 'icon-yiban'
            },
            {
                id: 30,
                name: '满意',
                icon: 'icon-manyi'
            }
        ]
    }
}
